import { setupApollo } from '../lib/apollo_setup';
import { SENDBIRD_UNREAD_MESSAGE_QUERY } from '@/graphql/messages/queries';

// Function to get Sendbird unread message count using Apollo
export async function getUnreadMessageCount() {
  const apolloProvider = setupApollo();

  const res = await apolloProvider.defaultClient.query({
    query: SENDBIRD_UNREAD_MESSAGE_QUERY,
  });

  return res.data.unreadMessageCount;
}

// Function to get unread message count and update UI
async function setUnreadMessageCount() {
  const count = await getUnreadMessageCount();
  const navMessageElements = document.getElementsByClassName('nav-messages');

  for (let i = 0; i < navMessageElements.length; i += 1) {
    const navMessageElement = navMessageElements[i];
    let unreadMessagesCount = navMessageElement.getElementsByClassName('nav-unread-messages-count')[0];

    if (count > 0) {
      if (unreadMessagesCount) {
        unreadMessagesCount.innerHTML = count;
      } else {
        unreadMessagesCount = document.createElement('span');
        unreadMessagesCount.className +=
          'nav-unread-messages-count bg-brand-contrast text-center text-foreground font-semibold inline-block h-20 w-20 rounded-full text-xs tracking-tighter leading-5 ml-8';
        unreadMessagesCount.innerHTML = count;
        navMessageElement.appendChild(unreadMessagesCount);
      }
    } else if (unreadMessagesCount) {
      unreadMessagesCount.remove();
    }
  }
}

// Pull unread count from graphql if user is on a page with a Messages nav item
// This function is needed for sitter nav and non-global parent nav
async function updateUnreadNavCount() {
  if (document.getElementsByClassName('nav-messages').length === 0) return;

  setUnreadMessageCount();
  const messageCountUpdateInterval = setInterval(setUnreadMessageCount, 10000);

  window.onbeforeunload = function () {
    clearInterval(messageCountUpdateInterval);
  };
}

updateUnreadNavCount();

export default getUnreadMessageCount;
